import React, { useState } from "react";
import PlusIcon from "../icons/BusinessHub/PlusIcon";
import CategoryRow from "./CategoryRow";

function CategoryList({
  categories,
  selectedCategoryId,
  onAddCategory,
  onSelectCategory,
  onToggleVisibility,
  onEditCategory,
  onDeleteCategory,
  onReorderCategories,
  orderDirty,
  onUploadOrder,
}) {
  const [draggedCategoryId, setDraggedCategoryId] = useState("");
  const [dragOverCategoryId, setDragOverCategoryId] = useState("");

  const clearDragState = () => {
    setDraggedCategoryId("");
    setDragOverCategoryId("");
  };

  const getCategoryIndex = (categoryId) =>
    categories.findIndex((category) => category.categoryId === categoryId);

  const handleDragStart = (event, categoryId) => {
    setDraggedCategoryId(categoryId);
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", categoryId);
  };

  const handleDragOver = (event, targetCategoryId) => {
    event.preventDefault();

    const sourceCategoryId =
      draggedCategoryId || event.dataTransfer.getData("text/plain");
    if (!sourceCategoryId || sourceCategoryId === targetCategoryId) return;

    const sourceIndex = getCategoryIndex(sourceCategoryId);
    const targetIndex = getCategoryIndex(targetCategoryId);
    if (sourceIndex === -1 || targetIndex === -1) return;

    setDragOverCategoryId(targetCategoryId);
    onReorderCategories(sourceIndex, targetIndex);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    clearDragState();
  };

  return (
    <div className="category-settings-panel">
      <div className="category-settings-panel-header">
        <div>
          <div className="category-settings-panel-title">Categories</div>
          <div className="category-settings-panel-meta">
            {categories.length} total
          </div>
        </div>
        <div className="category-settings-panel-actions">
          <button
            className="category-settings-upload-order-btn"
            onClick={onUploadOrder}
            disabled={!orderDirty}
          >
            Upload Order
          </button>
          <button
            className="category-settings-primary-btn"
            onClick={onAddCategory}
          >
            <PlusIcon fill="#ffffff" />
            <span>Add Category</span>
          </button>
        </div>
      </div>

      <div className="category-settings-list">
        {categories.length ? (
          categories.map((category) => (
            <CategoryRow
              key={category.categoryId}
              category={category}
              isSelected={category.categoryId === selectedCategoryId}
              isDragging={category.categoryId === draggedCategoryId}
              isDragOver={category.categoryId === dragOverCategoryId}
              onSelect={() => onSelectCategory(category.categoryId)}
              onDragStart={(event) =>
                handleDragStart(event, category.categoryId)
              }
              onDragOver={(event) =>
                handleDragOver(event, category.categoryId)
              }
              onDragEnter={() => setDragOverCategoryId(category.categoryId)}
              onDrop={handleDrop}
              onDragEnd={clearDragState}
              onToggleVisibility={() =>
                onToggleVisibility(category.categoryId)
              }
              onEdit={() => onEditCategory(category)}
              onDelete={() => onDeleteCategory(category)}
            />
          ))
        ) : (
          <div className="category-settings-empty-state">
            No categories have been added yet.
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoryList;
